export default "/images/airbnb.svg?c9f6f43d5cd777ae2a2ab458fc9309de";